module.exports = __webpack_public_path__ + "img/tv-blue.e60d20ba.svg";